exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.floorBox[data-v-11e8f439] {\n  height: 100%;\n  background: #222C5A;\n}", ""]);

// exports
